import React from "react";
import { cn } from "../../lib/utils";

const steps = [
  { id: 1, title: "Categoría" },
  { id: 2, title: "Descripción" },
  { id: 3, title: "Información extra" },
  { id: 4, title: "Datos a pedir" },
  { id: 5, title: "Revisión" },
];

const progressValues = [25, 44, 63, 83, 100]; // Valores personalizados

const LicitacionMenu = ({ currentStep }) => {
  const progressWidth = progressValues[currentStep - 1] || 0; // Asegura que no falle

  return (
    <div className="mb-8">
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
        <div
          className="h-full rounded-full bg-primary transition-all"
          style={{ width: `${progressWidth}%` }}
        ></div>
      </div>
      <div className="mt-3 flex flex-wrap justify-between gap-2">
        {steps.map((step) => (
          <div
            key={step.id}
            className={cn(
              "flex items-center gap-1.5 text-xs",
              currentStep >= step.id ? "text-primary" : "text-muted-foreground"
            )}
          >
            <span
              className={cn(
                "flex h-5 w-5 items-center justify-center rounded-full border text-[10px]",
                currentStep >= step.id ? "border-primary bg-primary text-primary-foreground" : "border-border"
              )}
            >
              {step.id}
            </span>
            <span className="hidden sm:inline">{step.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LicitacionMenu;
